import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { BasicQuestionGroupDto, QuestionGroupService } from '@proxy/question-groups';
import { firstValueFrom } from 'rxjs';
import { AppBaseComponent } from '../../app-base.component';

@Component({
    selector: 'app-question-group-dropdown',
    templateUrl: './question-group-dropdown.component.html',
    standalone: false
})
export class QuestionGroupDropdownComponent  extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() isCommon = false;
  @Input() questionGroup: BasicQuestionGroupDto;
  @Input() isDisabled: boolean;

  @Output() changeQuestionGroup = new EventEmitter<BasicQuestionGroupDto>();

  questionGroups: BasicQuestionGroupDto[];

  constructor(
    injector: Injector,
    private readonly _questionGroupService: QuestionGroupService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadQuestionGroups(this.isCommon);
    if (this.isNullOrUndefined(this.questionGroups)) {
      this.questionGroups = undefined;
    }
  }

  async loadQuestionGroups(isCommon: boolean): Promise<void> {
    try {
      this.showLoading();
      this.questionGroups = await firstValueFrom(this._questionGroupService.getAllQuestionGroupActivesByIsCommon(isCommon));
    } finally {
      this.hideLoading();
    }
  }

  onSelected(): void {
    this.changeQuestionGroup.emit(this.questionGroup);
  }
}
